import React, { useEffect } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { StaticBackdrop } from "../../../common/modal"
import IntlProps from "../../../state/helpers/IntlProps"
import { InventoryStockDocumentDefinitionAction, InventoryStockDocumentDefinitionSelector } from "../../../state/inventory"
import { DOCUMENT_TYPE_SELECT_SECTION_MESSAGES } from "../../../utils/inventory"
import { getStockDocumentDefinitionSelection } from "../../../utils/inventory/utils"


export const TypeSelection = injectIntl((props: IntlProps) => {
    const {id, isLoading, listing, isLoaded} = useSelector(InventoryStockDocumentDefinitionSelector.get)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isLoading && !isLoaded) {
            dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
        }
    },[])

    return (
        <StaticBackdrop>
            <label className="p-1 border-0">
                {props.intl.formatMessage(DOCUMENT_TYPE_SELECT_SECTION_MESSAGES["header"])}
            </label>

            <Select
                disabled={isLoading}
                className="col-3 pl-0 pb-1"
                options={getStockDocumentDefinitionSelection(listing)}
                value={id}
                onChange={(option) => {
                    dispatch(InventoryStockDocumentDefinitionAction.setFromListing(option.value))
                }}
            />

            <small className="text-muted">
                {props.intl.formatMessage(DOCUMENT_TYPE_SELECT_SECTION_MESSAGES["description"])}
            </small>
        </StaticBackdrop>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/TypeSelection.tsx